// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.applications.RentalManagerPdfRendererWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { ListingAlias } from '../..';

interface GetPropertySheetPdfParams {
  listingAlias: ListingAlias;
}

export const RentalManagerPdfRendererWebApiHandler_getPropertySheetPdf_Path =
  '/api/web/v1/users/applications/getPropertySheetPdf';

export const RentalManagerPdfRendererWebApiHandler_getPropertySheetPdf = (
  getParams: GetPropertySheetPdfParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetPropertySheetPdfParams, never, string>({
    getParams: getParams,
    endpoint: RentalManagerPdfRendererWebApiHandler_getPropertySheetPdf_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
